import { Column, Row } from "@tento-ui/component-builtin";
import { Button } from "@tento-ui/components/button/button";
import { Storybook } from "@tento-ui/ui/storybook";
import { Typography } from "@tento-ui/ui/typography";
import { TaskDateDisplay } from "./task-date-display";
import { TaskStorybook } from "./task-storybook-helpers";

export class TaskDateDisplayStoryBook extends Storybook.Default {
  title(): string {
    return "Task Date Display";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Date Formats",
        render: () => {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);

          const yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);

          const nextWeek = new Date();
          nextWeek.setDate(nextWeek.getDate() + 5);

          const nextMonth = new Date();
          nextMonth.setMonth(nextMonth.getMonth() + 1);

          const nextYear = new Date();
          nextYear.setFullYear(nextYear.getFullYear() + 1);

          const $today = TaskDateDisplay.make();
          $today.bind(new Date());

          const $tomorrow = TaskDateDisplay.make();
          $tomorrow.bind(tomorrow);

          const $yesterday = TaskDateDisplay.make();
          $yesterday.bind(yesterday);

          const $nextWeek = TaskDateDisplay.make();
          $nextWeek.bind(nextWeek);

          const $nextMonth = TaskDateDisplay.make();
          $nextMonth.bind(nextMonth);

          const $nextYear = TaskDateDisplay.make();
          $nextYear.bind(nextYear);

          const $noDate = TaskDateDisplay.make();
          $noDate.bind(null);

          return TaskStorybook.createIndicatorGrid({
            itemGap: "16px",
            items: [
              {
                $indicator: $today,
                label: "Today's date",
                labelColor: "var(--text-sec)",
                withPadding: true,
              },
              {
                $indicator: $tomorrow,
                label: "Tomorrow",
                labelColor: "var(--text-sec)",
                withPadding: true,
              },
              {
                $indicator: $yesterday,
                label: "Yesterday (overdue)",
                labelColor: "var(--text-sec)",
                withPadding: true,
              },
              {
                $indicator: $nextWeek,
                label: "5 days from now",
                labelColor: "var(--text-sec)",
                withPadding: true,
              },
              {
                $indicator: $nextMonth,
                label: "Next month",
                labelColor: "var(--text-sec)",
                withPadding: true,
              },
              {
                $indicator: $nextYear,
                label: "Next year",
                labelColor: "var(--text-sec)",
                withPadding: true,
              },
              {
                $indicator: $noDate,
                label: "No date set",
                labelColor: "var(--text-sec)",
                withPadding: true,
              },
            ],
          });
        },
      },
      {
        title: "Interactive Date Picker",
        render: () => {
          const $container = Column.make();
          $container.style.gap = "16px";

          const $display = TaskDateDisplay.make();
          $display.bind(new Date());
          $display.style.background = "var(--bg-hover)";
          $display.style.borderRadius = "4px";
          $display.style.padding = "2px 4px";
          $display.style.flexShrink = "0";

          const $inputRow = Row.make();
          $inputRow.style.gap = "8px";
          $inputRow.style.alignItems = "center";
          $inputRow.style.flexWrap = "wrap";

          const $dateInput = document.createElement("input");
          $dateInput.type = "date";
          $dateInput.value = new Date().toISOString().split("T")[0];
          $dateInput.style.padding = "2px 4px";
          $dateInput.style.borderRadius = "4px";
          $dateInput.style.border = "1px solid var(--divider)";

          $dateInput.onchange = () => {
            const selectedDate = new Date($dateInput.value);
            $display.bind(selectedDate);
          };

          const $clearButton = Button.makeWith("Clear Date", {
            type: "secondary",
            onClick: () => {
              $display.bind(null);
              $dateInput.value = "";
            },
          });

          $inputRow.appendChild($dateInput);
          $inputRow.appendChild($clearButton);

          const $displayRow = Row.make();
          $displayRow.style.alignItems = "center";
          $displayRow.style.gap = "8px";
          $displayRow.style.flexWrap = "wrap";
          $displayRow.appendChild(Typography.p("Selected:"));
          $displayRow.appendChild($display);

          $container.appendChild($inputRow);
          $container.appendChild($displayRow);

          return $container;
        },
      },
    ];
  }
}
